function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import MessageBusTransport from '@central-products/message-transport-bus';
import AccountActionsInterface, { AccountActionErrors } from '@central-products/interface-account-actions';
import { getDefaultActionData } from './defaultData';
import { emptyCallback, getActionData, getConfig, nextTick } from './utils';

var AccountActions =
/*#__PURE__*/
function (_AccountActionsInterf) {
  _inherits(AccountActions, _AccountActionsInterf);

  function AccountActions(_ref) {
    var _this;

    var language = _ref.language,
        env = _ref.env,
        regSource = _ref.regSource,
        isMobile = _ref.isMobile,
        transport = _ref.transport;

    _classCallCheck(this, AccountActions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccountActions).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "actions", new Map());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "actionRequested", emptyCallback);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "configArgs", void 0);

    (transport || MessageBusTransport.getInstance()).bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.configArgs = {
      language: language || 'en-gb',
      env: env || '',
      regSource: regSource,
      isMobile: isMobile
    };
    return _this;
  }

  _createClass(AccountActions, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      return getConfig().then(function (mappings) {
        return _this2.setEventsToActions(mappings);
      });
    }
  }, {
    key: "execute",
    value: function execute(request) {
      var _this3 = this;

      var eventId = request.eventId,
          context = request.context;
      var actionDetails = this.actions.get(eventId);

      if (!actionDetails) {
        return Promise.reject({
          error: AccountActionErrors.INVALID_EVENT_ID
        });
      }

      var actionId = actionDetails.actionId,
          actionType = actionDetails.actionType,
          pathToData = actionDetails.pathToData,
          defaultData = actionDetails.defaultData;
      var payload = {
        actionId: actionId,
        actionType: actionType,
        context: context,
        data: getActionData(context, pathToData) || getDefaultActionData({
          data: defaultData,
          config: this.configArgs,
          context: context
        })
      };
      nextTick(function () {
        _this3.actionRequested(payload);
      });
      return Promise.resolve({});
    }
  }, {
    key: "onActionRequested",
    value: function onActionRequested(callback) {
      this.actionRequested = callback;
      return function () {
        return emptyCallback;
      };
    }
  }, {
    key: "setEventsToActions",
    value: function setEventsToActions(mappings) {
      var _this4 = this;

      Object.keys(mappings).forEach(function (key) {
        return _this4.actions.set(key, mappings[key]);
      });
    }
  }]);

  return AccountActions;
}(AccountActionsInterface);

export { AccountActions as default };
//# sourceMappingURL=AccountActions.js.map